import {
  regex
} from 'vuelidate/lib/validators/common';
import {
  phoneRegex,
  phoneRegexLength,
} from '@/constants';

const validPhone = regex('validPhone', phoneRegex);
const validPhoneLength = regex('validPhoneLength', phoneRegexLength);
const phone = regex('phone', phoneRegex);

export {
  validPhone,
  validPhoneLength,
  phone,
};